import { NotificationType } from '~/app/enums/NotificationId';

export const enabledBENotifications = [NotificationType.DEVICE_DISCONNECTED, NotificationType.INFUSION_IN_ERROR];
